import { useMemo } from "react";
import { CHECKUP_SURVEY_IDS_DEV, CHECKUP_SURVEY_IDS_PROD, CHECKUP_SURVEY_TEST_IDS_DEV, CHECKUP_SURVEY_TEST_IDS_PROD, ENVIRONMENT, HEALTH_ASSESSMENT_IDS_DEV, HEALTH_ASSESSMENT_IDS_PROD, KEY_QUESTIONS_IDS_DEV, KEY_QUESTIONS_IDS_PROD } from "../../../utils/Constants";
import { Environment } from "../../../utils/enums/Environment";
import { useAuthStore } from "../../../utils/stores/useAuthStore";
import { useIsMetabolicUser } from "../../metabolic-health/hooks/useMetabolicHealth";
import { HEALTH_ASSESSMENT_IDS_DEV_METABOLIC, HEALTH_ASSESSMENT_IDS_PROD_METABOLIC } from "../utils/constants";

export const useInitializeSurveyQuestions = () => {
    const isMetabolicUser = useIsMetabolicUser();
    const { auth } = useAuthStore();
    
    // Special user ID that should use test checkup survey IDs
    const TEST_USER_ID = "17709960-4626-4244-897a-d3107d7f88d7";
    const isTestUser = auth.userId === TEST_USER_ID;

    // Memoize to prevent unnecessary re-renders
    const surveyData = useMemo(() => {
        let healthAssessmentIds: string[] = [];
        let checkupIds: string[] = [];
        let keyIds: string[] = [];

        switch (ENVIRONMENT) {
            case Environment.DEVELOP:
                healthAssessmentIds = isMetabolicUser ? HEALTH_ASSESSMENT_IDS_DEV_METABOLIC : HEALTH_ASSESSMENT_IDS_DEV;
                checkupIds = isTestUser ? CHECKUP_SURVEY_TEST_IDS_DEV : CHECKUP_SURVEY_IDS_DEV;
                keyIds = KEY_QUESTIONS_IDS_DEV;
                break;
            case Environment.PRODUCTION:
                healthAssessmentIds = isMetabolicUser ? HEALTH_ASSESSMENT_IDS_PROD_METABOLIC : HEALTH_ASSESSMENT_IDS_PROD;
                checkupIds = isTestUser ? CHECKUP_SURVEY_TEST_IDS_PROD : CHECKUP_SURVEY_IDS_PROD;
                keyIds = KEY_QUESTIONS_IDS_PROD;
                break;
            case Environment.STAGE:
                return { healthAssessmentIds: [], checkupIds: [], keyIds: [] }; // Avoid returning undefined
        }

        return { healthAssessmentIds, checkupIds, keyIds };
    }, [isMetabolicUser, isTestUser]); // Recalculate if `isMetabolicUser` or `isTestUser` changes

    return surveyData;
};